// extracted by mini-css-extract-plugin
module.exports = {"recoverPasswordForm":"_130why","actions":"NOFnjo","linkBack":"_3SkW64","field":"_1L9_sL","resetPassword":"_3gt7qm","shine-lines":"_1d9mnL"};